<template>
  <div :style="{bottom:visible?'0':'-240px'}" class="select-color">
    <div class="title">
      选择轮廓颜色
    </div>
    <div class="color-pal">
      <div
        v-for="i in colors"
        :key="i"
        :class="{active:color===i}"
        :style="{'background-color':i}"
        class="color-item"
        @click="changeColor(i)"
      />
    </div>
    <van-button native-type="button" type="primary" size="small" class="confirm-btn" @click="$emit('update:visible', false)">
      确定
    </van-button>
  </div>
</template>

<script>
export default {
  name: 'ColorPalette',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#00FF00'
    }
  },
  data() {
    return {
      colors: ['#E49357', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#FF00FF', '#D0DF9F', '#B4D39E', '#DD6F4C',
        '#64C3A4', '#FFF376', '#BAD174', '#42B5E9', '#6848FF', '#A3639D', '#DB71A1', '#DC7079', '#E79B2F',
        '#9BC144', '#FF0004', '#00954D', '#009FE2', '#9CE8E8', '#0C74E4', '#86227F', '#5CC8C8', '#B05959',
        '#B6AA37']
    }
  },
  methods: {
    changeColor(color) {
      this.$emit('update:color', color)
      this.$emit('change', color)
    }
  }
}
</script>

<style lang="less" scoped>
.select-color {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 0 20px;
  background-color: rgba(40,43,49,.9);
  box-shadow: -6px 0 20px -5px rgba(0,0,0,.4);
  transition: bottom .3s ease;
  > .title {
    color: @primary-color;
    line-height: 32px;
    font-weight: 500;
    text-align: center;
  }
}
.color-pal {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(4, 30px);
  justify-items: center;
  align-items: center;
  width: 250px;
  padding: 10px;
  margin: auto;
  background-color: rgba(245, 245, 245, .2);
  border: 1px solid rgba(255, 255, 255, .2);
  border-radius: 3px;
  font-size: 0;
  div {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    transition: all .1s linear;
    &.active::after {
      position: absolute;
      top: -4px;
      left: -4px;
      content: "";
      width: 26px;
      height: 26px;
      border: 1px solid #999;
      border-radius: 3px;
    }
  }
}
.confirm-btn {
  position: absolute;
  right: 10px;
  top: 0;
  width: 50px;
}
</style>
